var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSave = function SvgIconSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".807em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9DA0A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.95,
    d: "M1 3.9a2.6 2.6 0 0 1 2.6-2.6h13a2.6 2.6 0 0 1 2.6 2.6v20.8l-9.1-4.55L1 24.7z"
  })));
};
export default SvgIconSave;